import { render } from "./HistoriqueExam.vue?vue&type=template&id=560c6729"
import script from "./HistoriqueExam.vue?vue&type=script&lang=js"
export * from "./HistoriqueExam.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__